import postWithResponse from '@services/api/common/postWithResponse';
import appConfig from '@configs/appConfig';

export const testConnection = data =>
  postWithResponse(`${appConfig.baseUrl}/FtpConnections/test`, data);
